'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var IneligibleReasonChip = require('../../components/IneligibleReasonChip.js');
var Markdown = require('../../components/Markdown/Markdown.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageSelectionCardUnselected = _ref => {
  let {
    shipment
  } = _ref;
  const {
    claimsIneligibilityPackageBeingReturned,
    claimsIneligibilityPackageItemsClaimed,
    claimsIneligibilityPackageItemNotListedAsEligible,
    claimsIneligibilityPackageItemsReturned,
    claimsIneligibilityPackageItemsReturnedOrClaimed,
    claimsIneligibilityPackageNoEligibleItems,
    claimsIneligibilityPackageTooEarly,
    claimsIneligibilityPackageDeliveredTooEarly,
    claimsIneligibilityPackageTooLate,
    claimsIneligibilityPackageBopisItemsNotEligible,
    claimsIneligibilityNoMultiPackageClaimsPackage,
    claimsIneligibilityPackageNotDeliveredTooLate
  } = nthHookTranslations.useTranslations();
  const eligibilityReasonText = {
    PackageBeingReturned: claimsIneligibilityPackageBeingReturned ?? '',
    TooEarly: claimsIneligibilityPackageTooEarly ?? '',
    PackageNotDeliveredTooLate: claimsIneligibilityPackageNotDeliveredTooLate ?? '',
    DeliveredTooEarly: claimsIneligibilityPackageDeliveredTooEarly ?? '',
    TooLate: claimsIneligibilityPackageTooLate ?? '',
    ItemsClaimed: claimsIneligibilityPackageItemsClaimed ?? '',
    ItemNotListedAsEligible: claimsIneligibilityPackageItemNotListedAsEligible ?? '',
    ItemsReturned: claimsIneligibilityPackageItemsReturned ?? '',
    ItemReturnedOrClaimed: claimsIneligibilityPackageItemsReturnedOrClaimed ?? '',
    NoEligibleItems: claimsIneligibilityPackageNoEligibleItems ?? '',
    BopisItemNotEligible: claimsIneligibilityPackageBopisItemsNotEligible ?? '',
    // Dynamic values
    SinglePackageClaimRestriction: claimsIneligibilityNoMultiPackageClaimsPackage ?? ''
  };
  const {
    ineligibilityReason,
    ineligibilityReasonMessage
  } = shipment.evaluatedEligibility;
  return ineligibilityReason && /*#__PURE__*/React__default["default"].createElement(IneligibleReasonChip["default"], null, /*#__PURE__*/React__default["default"].createElement(Markdown["default"], {
    markdown: ineligibilityReasonMessage || eligibilityReasonText[ineligibilityReason]
  }));
};
var PackageSelectionIneligibilityReason = nthHookTranslations.withTranslationsProvider(PackageSelectionCardUnselected, {
  translationKeys: ['claimsIneligibilityPackageBeingReturned', 'claimsIneligibilityPackageItemsClaimed', 'claimsIneligibilityPackageItemNotListedAsEligible', 'claimsIneligibilityPackageItemsReturned', 'claimsIneligibilityPackageItemsReturnedOrClaimed', 'claimsIneligibilityPackageNoEligibleItems', 'claimsIneligibilityPackageTooEarly', 'claimsIneligibilityPackageBopisItemsNotEligible', 'claimsIneligibilityPackageDeliveredTooEarly', 'claimsIneligibilityPackageTooLate', 'claimsIneligibilityNoMultiPackageClaimsPackage', 'claimsIneligibilityPackageNotDeliveredTooLate']
});

exports["default"] = PackageSelectionIneligibilityReason;
